import * as types from "../ActionType";

const initState = {
    users: [],
    loadingUsers: true
}

const AuthReducer = (state = initState, action) => {
    switch (action.type) {
        case types.LOGIN_ADMIN:
            return { ...state }
        case types.LOGOUT_ADMIN:
            return { ...state }
        case types.GET_USERS:
            return { ...state, users: action.payload, loadingUsers: false }
        case types.SEND_NOTIFICATIONS:
            return { ...state }
        default:
            return state;
    }
};

export default AuthReducer;
